/** Identifiant d’idempotence conservé par le formulaire jusqu’à modification de ses paramètres. */
export const studioRequestId = (): string => globalThis.crypto?.randomUUID?.()
  ?? 'studio-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
